import React from 'react';
export function ProblemSection() {
  return <section className="py-8 px-4 bg-gray-50" data-id="element-97" data-mp="14h4zv2xnw1xw">
      <div className="max-w-3xl mx-auto" data-id="element-98" data-mp="2lstjzhrrqcfl">
        <h2 className="text-[20px] font-black mb-5 text-center text-[#EF5B4C]" data-id="element-99" data-mp="2ltw85hxpi0rt">
          NO TODOS LOS TEMAS DE ESI SON FÁCILES DE TRABAJAR
        </h2>

        <p className="text-lg mb-5 text-center text-gray-700" data-id="element-100" data-mp="2vpz9wmonbxe8">
          Muchas veces los docentes tienen la intención de abordar emociones,
          convivencia, diversidad o ciudadanía digital, pero no cuentan con
          materiales claros, visuales y listos para usar.
        </p>

        <p className="text-lg md:text-xl text-center font-[800] text-[#8F7DA6]" data-id="element-101" data-mp="3jftob8om5u0l">
          Material listo para trabajar ESI en todos los grados, sin armar nada
          desde cero.
        </p>
      </div>
    </section>;
}